export default "/assets/images/mila-room-showcase-03.jpg?9d96de71f3808f34173d16eb4cd9a330";